import { render, staticRenderFns } from "./FieldsGroupWrapper.vue?vue&type=template&id=0ecf39df&scoped=true&"
import script from "./FieldsGroupWrapper.vue?vue&type=script&lang=js&"
export * from "./FieldsGroupWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecf39df",
  null
  
)

export default component.exports